import { useState } from "react";
import { Link } from "react-router-dom";
import {
    Eye,
    Shield,
    Film,
    Camera,
    Layers,
    Cpu,
    ArrowUpRight,
} from "lucide-react";
import "./ServicesPage.css";
import Service_BG from "../components/ui/Services.png";
import IntelliTrackIcon from '../components/ui/IntelliTrack.svg'
import VirtualProductions from '../components/ui/VirtualProductions.svg'
import ImmersiveExp from '../components/ui/ImmersiveExp.svg'
import InterExh from '../components/ui/IntExhi.svg'
import DefenceImg from '../components/ui/defence.svg'
import DroneImg from '../components/ui/drone.svg'



const SERVICES = [
    {
        icon: Eye,
        title: "Immersive Experiences",
        desc: "Creating immersive experiences through AR, projection mapping, holograms, and interactive visual technologies for public spaces, cultural landmarks, corporate environments, and large-scale events.",
        img: ImmersiveExp
    },
    {
        icon: Shield,
        title: "Defence Training Solutions",
        desc: "Mission-critical simulation systems engineered for defence training, featuring high-fidelity VR/MR environments for radar, missile, drone, armoured vehicle, parachute, and close-quarters battle operations. ",
        img: DefenceImg,
    },
    {
        icon: Film,
        title: "Virtual Productions",
        desc: "End-to-end virtual production solutions powered by LED volume technology, enabling cinematic-quality content creation for films, OTT platforms, commercials, broadcast, and live productions",
        img: VirtualProductions,
    },
    {
        icon: Camera,
        title: "IntelliTrack™ - Camera Tracking",
        desc: "India's first patented markerless camera tracking system, enabling fast deployment and precision tracking for handheld, jib, crane, and broadcast camera setups in both indoor and outdoor environments.",
        img: IntelliTrackIcon,
    },
    {
        icon: Layers,
        title: "Interactive Exhibits",
        desc: " Interactive exhibits that combine 3D anamorphic displays, touch-enabled technologies, and immersive storytelling to create engaging museum and visitor experiences. ",
        img: InterExh,
    },
    {
        icon: Cpu,
        title: "Innovation Lab",
        desc: "Our innovation hub for embedded systems, AI, IoT, robotics, and intelligent hardware development, driving next-generation technologies across every solution we deliver. ",
        img: DroneImg,
    },
];



export default function ServicesPage() {

    const [expandedIds, setExpandedIds] = useState({});

    const toggleExpand = (title, e) => {
        e.stopPropagation();
        setExpandedIds(prev => ({
            ...prev,
            [title]: !prev[title]
        }));
    };

    return (
        <main data-testid="services-page" className="services-page-wrapper">
            {/* Hero */}
            <section className="services-hero border-bottom position-relative overflow-hidden">
                <div
                    className="hero-bg-image"
                    style={{ backgroundImage: `url(${Service_BG})` }}
                    aria-hidden
                />
                <div
                    className="hero-overlay"
                    aria-hidden
                />
                <div className="grain position-absolute top-0 bottom-0 start-0 end-0 pe-none" aria-hidden />

                <div className="container-db position-relative">
                    <div className="font-mono-tech section-eyebrow fade-in-up fs-5">
                        ⟶ Capabilities
                    </div>
                    <h1
                        data-testid="services-page-title"
                        className="font-heading hero-title mb-0"
                    >
                        Tech + Creativity
                        <br />
                        <span className="text-primary-custom">Transformed</span>
                    </h1>
                    <p className="services-hero-desc mt-4 mb-0" style={{ fontSize: '20px' }}>
                        We combine engineering, creativity, and emerging technologies to deliver immersive, intelligent, and future-ready solutions across industries.
                    </p>
                </div>
            </section>

            {/* Service cards */}
            <section className="py-5 py-md-10">
                <div className="container-db">
                    <div className="row g-3">
                        {SERVICES.map((s, i) => {
                            const Icon = s.icon;
                            return (
                                <div key={s.title} className="col-12 col-lg-6">
                                    <article
                                        data-testid={`service-card-${s.title.replace(/[\s·]+/g, "-").toLowerCase()}`}
                                        className="position-relative overflow-hidden group-hover-parent service-card bg-dark"
                                    >
                                        <div
                                            className="service-card-img bg-cover bg-center"
                                            style={{ backgroundImage: `url(${s.img})` }}
                                        />
                                        <div className="service-card-overlay" />
                                        <div className="position-relative h-100 p-3 d-flex flex-column justify-content-between service-card-content">
                                            <div className="d-flex align-items-center justify-content-between">
                                                <span className="font-mono-tech card-label">
                                                    {/* 0{i + 1} / Service */}
                                                </span>
                                                <Icon size={24} className="text-white" />
                                            </div>
                                            <div>
                                                <h3 className="font-heading card-title mb-2" style={{ color: '#40e0d0' }}>
                                                    {s.title}
                                                </h3>
                                                <p
                                                    className={`card-desc service-card-desc max-w-xl ${expandedIds[s.title] ? "is-expanded" : ""}`}
                                                    onClick={(e) => toggleExpand(s.title, e)}
                                                    style={{ cursor: "pointer" }}
                                                >
                                                    {s.desc}
                                                </p>
                                            </div>
                                        </div>
                                    </article>
                                </div>
                            );
                        })}
                    </div>
                </div>
            </section>

            {/* CTA */}
            <section className="py-5 border-top border-secondary">
                <div className="container-db">
                    <div className="d-flex flex-column gap-3 text-center align-items-center justify-content-center">
                        <h3 className="font-heading section-heading mb-0" style={{ fontSize: '24px' }}>
                            Ready to engineer the impossible?
                        </h3>
                        <p className="mb-0 text-secondary" style={{ fontSize: '16px', maxWidth: '600px' }}>
                            Partner with DB Productions to build the future through technology, creativity, and engineering.
                        </p>
                        <Link
                            to="/contact"
                            data-testid="services-cta-contact"
                            className="btn-submit font-mono-tech text-decoration-none text-dark fw-bold text-nowrap"
                            style={{ whiteSpace: 'nowrap', width: 'auto' }}
                        >
                            Start a Project <ArrowUpRight size={16} />
                        </Link>
                    </div>
                </div>
            </section>
        </main>
    );
}
